var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLilArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.985 3.51501L5.5 12L13.985 20.485L15.4 19.071L8.328 12L15.4 4.92901L13.985 3.51501Z",
    fill: "#242731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLilArrowLeft);
export default __webpack_public_path__ + "static/media/lilArrowLeft.9cd4a3aee65fc3407afa6b0545d56120.svg";
export { ForwardRef as ReactComponent };